import { useEffect, useState } from 'react';
import {
  MONKEY_SPIN_EVENT,
  readMonkeySpinPaused,
  writeMonkeySpinPaused
} from '../utils/monkeyRotation';

const useMonkeySpinPaused = () => {
  const [paused, setPaused] = useState(() => readMonkeySpinPaused());

  useEffect(() => {
    const onChange = (event) => {
      setPaused(!!event.detail?.paused);
    };
    window.addEventListener(MONKEY_SPIN_EVENT, onChange);
    return () => window.removeEventListener(MONKEY_SPIN_EVENT, onChange);
  }, []);

  const setMonkeySpinPaused = (next) => {
    writeMonkeySpinPaused(next);
    setPaused(!!next);
  };

  return [paused, setMonkeySpinPaused];
};

export default useMonkeySpinPaused;
